import styled from 'styled-components';

/** Visual state of the BDL cell, tinting the input and the check button as one. */
export const PREPARED_QUANTITY_VARIANT = {
  NEUTRAL: 'neutral',
  COMPLIANT: 'compliant',
  NON_COMPLIANT: 'nonCompliant',
  DISABLED: 'disabled',
};

const getInputBackgroundColor = ({ theme, variant }) => {
  if (variant === PREPARED_QUANTITY_VARIANT.COMPLIANT) {
    return theme.colors.brand.primaryLight;
  }

  if (variant === PREPARED_QUANTITY_VARIANT.NON_COMPLIANT) {
    return theme.colors.infoLightOrange;
  }

  if (variant === PREPARED_QUANTITY_VARIANT.DISABLED) {
    return theme.colors.greys.light;
  }

  return theme.colors.greys.lightest;
};

const getBorderColor = ({ theme, variant }) => {
  if (variant === PREPARED_QUANTITY_VARIANT.COMPLIANT) {
    return theme.colors.infoGreen;
  }

  if (variant === PREPARED_QUANTITY_VARIANT.NON_COMPLIANT) {
    return theme.colors.infoOrange;
  }

  if (variant === PREPARED_QUANTITY_VARIANT.DISABLED) {
    return theme.colors.greys.light;
  }

  return theme.colors.greys.medium;
};

const getCheckButtonBackgroundColor = ({ theme, variant }) => {
  if (variant === PREPARED_QUANTITY_VARIANT.COMPLIANT) {
    return theme.colors.infoGreen;
  }

  if (variant === PREPARED_QUANTITY_VARIANT.NON_COMPLIANT) {
    return theme.colors.infoOrange;
  }

  if (variant === PREPARED_QUANTITY_VARIANT.DISABLED) {
    return theme.colors.greys.light;
  }

  return theme.colors.greys.lightest;
};

/** The colored variants paint the divider as the button, so only the grey ones draw a visible one. */
const getDividerColor = (props) => {
  if (props.variant === PREPARED_QUANTITY_VARIANT.NEUTRAL) {
    return props.theme.colors.greys.medium;
  }

  if (props.variant === PREPARED_QUANTITY_VARIANT.DISABLED) {
    return props.theme.colors.greys.medium;
  }

  return getCheckButtonBackgroundColor(props);
};

/** Input and check button fused into a single control: one border, one radius, an inner divider. */
export const CellContainer = styled.div`
  height: 40px;
  width: fit-content;

  display: flex;
  align-items: stretch;

  overflow: hidden;
  border-radius: 8px;
  border: 1px solid ${getBorderColor};
  background-color: ${getInputBackgroundColor};
`;

export const QuantityInput = styled.input`
  width: 88px;
  padding: 0 8px;

  text-align: center;
  font: ${({ theme }) => theme.fonts.textSmallHeight16};
  color: ${({ theme, variant }) =>
    variant === PREPARED_QUANTITY_VARIANT.DISABLED
      ? theme.colors.greys.darker
      : theme.colors.greys.darkest};

  outline: none;
  border: none;
  background-color: transparent;
`;

export const CheckButton = styled.button`
  width: 40px;
  min-width: 40px;

  display: flex;
  align-items: center;
  justify-content: center;

  border: none;
  border-left: 1px solid ${getDividerColor};
  background-color: ${getCheckButtonBackgroundColor};

  cursor: ${({ variant }) =>
    variant === PREPARED_QUANTITY_VARIANT.DISABLED ? 'default' : 'pointer'};
`;

export const CheckIcon = styled.img`
  width: 16px;
  height: 16px;
`;
